/*global $ */

$('body').on('focusin', '.GeographyAutoComplete', function (e) {
  var $target = $(e.target);
  $target.data('ga-initial', $target.val());
});

$('body')
  .on('geographyautocompleteclose', 'form', GeographyAutocompleteClose)
  .on('geographyautocompletecreate', 'form', GeographyAutocompleteCreate)
  .on('geographyautocompletefocus', 'form', GeographyAutocompleteFocus);

function GeographyAutocompleteCreate(e) {
  var $target = $(e.target);
  $target.on('change', GeographyAutocompleteClose);
}

function GeographyAutocompleteClose(e) {
  var $target = $(e.target);
  if (!$($target.data('geographyautocomplete-suggestionid-field')).val()) {
    if ($target.val() == $target.data('ga-text') && $target.data('ga-suggestionid')) {
      $($target.data('geographyautocomplete-suggestionid-field')).val($target.data('ga-suggestionid')).trigger('change');
      $target.data('ga-initial', $target.data('ga-text').split(',')[0].trim());
    } else if ($target.val()) {
      $target.val($target.data('ga-initial'));
      return false;
    }
  }
  $target.data('ga-text', '');
  $target.data('ga-suggestionid', '');
}

function GeographyAutocompleteFocus(e, ui) {
  var $target = $(e.target);
  if (e.originalEvent && e.originalEvent.originalEvent && e.originalEvent.originalEvent.type === 'keydown') {
    if (ui.item) {
      $target.data('ga-text', ui.item.value);
      $target.data('ga-suggestionid', ui.item.suggestionId);
    } else {
      $target.data('ga-text', '');
      $target.data('ga-suggestionid', '');
    }
  }
}
